const { SESSION_REPLAY } = require('../../constants/initiatives');
const pick = require('../utils/pick');
const { getConfiguration } = require('../config');
const { METRICS } = require('../../constants/configurations');

const preparePayload = (_, data) => {
  const metrics = getConfiguration(METRICS, SESSION_REPLAY);
  const collection = pick(data, metrics);

  if (!Object.keys(collection).length) {
    throw new Error('Metrics not found');
  }

  return {
    name: SESSION_REPLAY,
    data: collection,
  };
};

module.exports = preparePayload;
